import React from 'react';

function Footer() {
  return (
    <footer >
      <p>&copy; 2023 Bhagyesh Sunil Chaudhari</p>
    </footer>
  );
}

// const footerStyle = {
//   backgroundColor: '#333',
//   color: '#fff',
//   textAlign: 'center',
//   padding: '10px',
//   position: 'fixed',
//   bottom: '0',
//   width: '100%',
// };

export default Footer;
